// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_article_card_skeleton_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 5px;
}
.home_article_first_card_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  width: 95% !important;
}

.home_article_card_details_skeleton_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  justify-content: space-between;
  align-items: flex-end;
}
.home_article_card_details_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 7px;
  width: 45% !important;
}

.home_article_card_skeleton_author_details_wrapper {
  display: flex;
  justify-content: space-between;
}
.home_article_card_author_details_wrapper {
  display: flex;
  justify-content: space-between;
  width: 100% !important;
}
.home_article_card_author_details_container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.ant-skeleton.ant-skeleton-element .ant-skeleton-input {
  min-width: 0px;
}
.home_articles_container {
  width: 100%;
  height: 400px;
}

.fact_check_middle_card_skeleton_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.home_article_card_skeleton_author_details_wrapper {
  display: flex;
  justify-content: space-between;
}

.ant-skeleton.ant-skeleton-element .ant-skeleton-input {
  min-width: 0px;
}
.home_articles_container {
  width: 100%;
  height: 400px;
}

.fact_check_middle_card_container {
  height: 400px;
}

.exposing_fake_news_second_section {
  display: flex;
  justify-content: space-between !important;
  flex-direction: column;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  width: 25%;
  gap: 5px;
  border-radius: 0 0 10px 10px;
  z-index: 1;
  background-color: white;
}


.fact_check_middle_card_image {
  width: 100% !important;
  width: 25%;
}

.exposing_fake_news_wrapper {
  width: 90%;
  justify-content: space-between;
  height: 100%;
}
.exposing_fake_news_second_column_image {
  width: 100% !important;
}

.fact_check_middle_card_title_wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 4% 0 4%;
}

.fact_check_middle_card_sub_title_wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 4% 0 4%;
}
.fact_check_middle_card_title_skeleton {
  width: 100% !important;
}
.fact_check_middle_card_sub_title_skeleton {
  width: 100% !important;
}


.exposing_fake_news_details_skeleton {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
}

.fact_check_middle_card_sub_title_container {
  padding: 0 4% 0 4%;
  overflow: hidden;
}
.fact_check_middle_card_details_container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 4% 0 4%;
}
.fact_check_middle_card_details_wrapper {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.fact_check_middle_card_details {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fact_check_middle_card_title_container {
  padding: 0 4% 0 4%;
}

.fact_check_continue_reading {
  cursor: pointer;
  text-decoration: underline;
  color: #0d99ff;
  font-size: 12px;
}

.home_slot_card_views_wrapper {
  display: flex;
  justify-content: space-between;
}
.home_article_first_column_container {
  display: flex;
  justify-content: center;
}
.home_article_first_column_wrapper {
  display: flex;
  flex-direction: row;
  width: 90%;
}
.home_article_card_thumbnail_container {
  border-radius: 5px 0px 0px 5px;
  object-fit: cover !important;
  width: 55% !important;
}
.home_article_second_column {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 52%;
}
.home_article_title_text {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
}

.title_text {
  font-weight: bold;
}
.sub_title_text {
  color: gray;
}
.home_article_row_container {
  width: 100% !important;
  display: flex;
  justify-content: center;
}
.home_article_row_wrapper {
  height: 100% !important;
  width: 90%;
  display: flex;
  justify-content: space-between;
}
.home_article_trending_container {
  width: 24%;
  border-radius: 8px;
  z-index: 1;
  display: flex !important;
  flex-direction: column;
  justify-content: flex-end !important;
  position: relative;
  cursor: pointer !important;
  overflow: hidden !important;
}
.home_article_trending_container:hover .home_article_trending_details_container {
  overflow: hidden !important;
  transform: translateY(60px); 
}

.related_fact_check_card {
  border-radius: 8px;
  z-index: 1;
  display: flex !important;
  flex-direction: column;
  justify-content: flex-end !important;
  position: relative;
  cursor: pointer !important;
  overflow: hidden !important;
}
.related_fact_check_card:hover .home_article_trending_details_container{
  transform: translateY(60px) !important;
  overflow: hidden !important;
}

.home_article_trending_details_container {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.75) !important;
  z-index: 2;
  position: absolute;
  border-radius: 0px 0px 7px 7px;
  padding: 5px;
  gap: 3px !important;
  min-height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.6s ease-in; 

  overflow: hidden !important;
}
.home_article_trending_title_container {
  width: 100%;
  overflow: hidden;
}
.home_article_trending_author_container {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.home_trending_title_text {
  color: white;
  font-family: kufam;
  font-weight: 600;
}
.home_article_trending_thumbnail {
  border-radius: 8px 0px 0px 8px !important;
  object-fit: cover;
  width: 100% !important;
  height: 100% !important;
}

.home_article_card_author_details {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.view_icon {
  padding-right: 3px !important;
  color: var(--view-icon-color);
}
.is_red {
  color: var(--view-icon-color);
}
.reading_icon {
  padding-right: 3px !important;
  color: gray;
}

.home_article_author_view_container {
  display: flex;
  justify-content: center;
}
.home_article_card_time_container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.exposing_fake_news_details_skeleton {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
}

.exposing_fake_news_second_column_sub_title_container {
  padding: 0 4% 0 4%;
  overflow: hidden;
}
.exposing_fake_news_second_column_details_container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 4% 0 4%;
}
.exposing_fake_news_second_column_details_wrapper {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.exposing_fake_news_second_column_details {
  display: flex;
  align-items: center;
  color: #808080 !important;
  gap: 5px;
}
.exposing_fake_news_second_column_title_container {
  padding: 0 4% 0 4%;
}
.fact_check_continue_reading_wrapper {
  padding: 0 4% 2% 4%;
  display: flex;
  align-items: center;
}
.fact_check_continue_reading {
  cursor: pointer;
  text-decoration: underline;
  color: #0d99ff;
}

.home_slot_card_views_wrapper {
  display: flex;
  justify-content: space-between;
}
.user-contributed-background-theme {
  background-color: var(--background-theme-color);
  color: white !important;
}
.member-button {
  background-color: var(--become-member-button);
  color: white !important;
}
.border-shadow {
  box-shadow: rgba(0, 101, 204, 0.1) 0px 0px 10px 10px !important;
  border: 0px solid white !important;
}

.h-10 {
  height: 10% !important;
}
.w-10 {
  width: 10%;
}
.radius-50 {
  border-radius: 50%;
}
.view-count-tag {
  color: var(--view-icon-color);
  font-size: 10px;
}
.time-tag {
  color: gray;
}
.user_contributed_story_container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 1px 1px 10px 10px;
  height: 620px;
}
.home_user_contribute_title {
  font-size: 14px;
  font-weight: 700;
  font-family: "Lato_Bold";
}
.home_user_contribute_mobile_title {
  font-size: 12px;
  font-family: "Lato";
  font-weight: 600;
}

.user_contributed_story_container_image {
  height: 150px;
  object-fit: fill;
}

.user_contributed_story_text_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  height: 100%;
  gap: 20px;
}
.home_user_contribute_subtitle {
  font-size: 10px;
  color: #61666d;
  font-family: "Lato";
  font-weight: 500px;
  line-height: 16px;
}
.display_flex {
  display: flex !important;
}
.flex_direction_row {
  flex-direction: row !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.align-center {
  align-items: center !important;
}
.gap_10 {
  gap: 5px !important;
}

.flex-column {
  flex-direction: column;
}
.continue_reading_text {
  color: #0d99ff;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
}
.continue_reading_text_ta {
  color: #0d99ff;
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
}
.contribute_user_name {
  color: gray;
}

.home_user_contribute_container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.user_contribution_mobile_card_footer,
.home_user_contribute_mobile_title {
  padding: 10px;
}

.user_contributed_story_column_container {
  background-color: var(--background-theme-color);
  height: 100%;
  
  display: flex;
  flex-direction: column;
  border-radius: 20px;
}
.user_contributed_story_column_box {
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.empower_truth_tag {
  color: var(--tag-color);
  font-weight: 600;
  font-family: "Kufam";
}
.become_a_member_button {
  background-color: #0d99ff;
  color: white;
  border: 1px solid #0d99ff !important;
}
.become_member_content {
  font-size: 20px;
  color: white;
  font-weight: 400 !important;
  font-family: "Lato";
}
.become_member_content_ta {
  font-size: 20px;
  color: white;
  font-weight: 500 !important;
  font-family: "Lato";
}

.exposing_fake_news_container {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 100%;
}
.inner_row_content {
  display: flex;
  flex-direction: column;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  z-index: 1;
  width: 100%;
  justify-content: flex-end;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  overflow: hidden !important;
}

.exposing_fake_news_first_column_details {
  background-color: rgba(20, 15, 45, 0.9) !important;
  z-index: 2;
  position: absolute;
  padding: 1%;
  margin-bottom: 2%;
  width: 80%;
}

.home_article_second_column_details {
  background-color: rgba(20, 15, 45, 0.9) !important;
  z-index: 2;
  position: absolute;
  padding: 1%;
  width: 80%;
  margin-bottom: 2%;
}
.exposing_fake_news_first_column_view_count {
  display: flex;
  align-items: center;
  gap: 10px;
}
.exposing_fake_news_first_column_view_icon {
  color: white;
}
.exposing_fake_news_first_column_button {
  background-color: #140f2d !important;
  color: #ffffff !important;
  border-radius: 10px;
  border: 1px solid white !important;
}
.exposing_fake_news_first_column_details_wrapper {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.exposing_fake_news_first_column_details_row {
  height: 55%;
  display: flex;
  align-items: center;
}
.exposing_fake_news_first_column_title {
  color: #ffffff;
}
.exposing_fake_news_first_column_writer_name_and_views {
  color: #ffffff;
}
.home_article_second_column_writer_name_and_views {
  color: #ffffff;
}
.exposing_fake_news_first_column_details_skeleton {
  z-index: 2;
  position: absolute;
  padding: 1%;
}

.exposing_fake_news_first_section {
  width: 45%;
}
.exposing_fake_news_third_section {
  width: 25%;
}
.home_videos_section {
  display: flex;
  background-color: #140f2d;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  padding-top: 50px;
}
.home_videos_first_column {
  width: 45%;
}
.home_videos_second_column {
  width: 45%;
  display: flex;
  justify-content: flex-end;
}
.home_videos_second_column_contents {
  width: 90%;
  display: grid;
  justify-content: flex-end;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  
}
.home_videos_title {
  width: 50%;
}
.home_videos_title_text {
  color: #fff;
  text-align: left;
  font-family: "Kufam";
}
.see_all_btn {
  background-color: transparent;
  border: 1px solid white;
  color: #fff;
}
.home_videos_title_row {
  display: flex;
  flex-direction: row;
  
}
.see_all_btn_position {
  display: flex;
  justify-content: flex-end;
  width: 50%;
}
.home_page_videos_text_content {
  color: #fff;
  font-size: large;
  width: 100%;
}
.home_page_videos_thumbnail {
  width: 100% !important;
  object-fit: cover;
  border-radius: 10px;
}
.home_page_videos_thumbnail_div {
  width: 100%;
  position: relative;
  cursor: pointer;
}
.home_videos_thumbnail_overlay_content {
  position: absolute;
  bottom: 20px;
  background-color: #ffffffcc;
  color: #fff;
  width: 60%;
  height: 80px;
  display: flex;
  
  justify-content: center;
}

.home_videos_subscribe_button {
  background-color: #ef1d26;
  color: #fff;
  border-radius: 10px;
  width: 50%;
  height: 40px;
  align-items: center;
  justify-content: space-around;
  display: flex;
  cursor: pointer;
}
.home_videos_subscribe_button_image {
  width: 20px;
}
.home_videos_subscribe_button_position {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.home_videos_thumbnail_overlay_play_icon {
  width: 50px;
  margin-left: 5px;
}
.home_videos_thumbnail_overlay_content_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.home_videos_thumbnail_overlay_text {
  color: #111;
  font-size: 14px;
}
.home_videos_thumbnail_overlay_viewed_text {
  font-size: 12px;
  color: #111;
}
.home_page_overlay_text_column {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.home_videos_second_column_image {
  width: 95%;
  border: 1.5px solid rgb(231, 231, 231);
  border-radius: 10px;
  object-fit: "cover";
  align-items: center;
  height: auto;
}
.home_videos_viewed_count_and_published {
  font-family: "Lato_Bold";
  color: #fff;
  font-size: 12px;
}
.home_videos_viewed_count_and_published_div {
  display: flex;
  width: 90%;
  margin-bottom: 10px;
}
.home_videos_mobile_view_contents {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 20px; 
  padding: 10px;
  background-color: #140f2d;
}

.home_videos_mobile_view_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.home_videos_mobile_view_image {
  width: 90%;
  border: 1.5px solid rgb(231, 231, 231);
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
}
.home_videos_section_mobile_view {
  background-color: #140f2d;
}
.home_page_videos_text_content_mobile_view {
  color: #fff;
  font-size: large;
  width: 100%;
  padding-top: 10px;
}
.home_awards_section {
  background: linear-gradient(147.32deg, #140f2d 40.85%, #f49d36 169.52%);
  width: 100%;
  /* height: 100%; */
}
.home_awards_section_title {
  font-family: "Kufam";
  color: #fff;
  font-size: 24px;
  margin-bottom: 20px;
  padding-top: 50px;
  padding-bottom: 20px;
  padding-left: 20px;
}
.home_awards_card_image {
  width: 100%;
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.905);
  opacity: 0.8;
}
.home_awards_card_div {
  display: flex;
  flex-direction: column;
  margin: 0 20px;
}

body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.container {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header h1,
.header h2 {
  margin: 0;
}

.content {
  display: flex;
  flex-wrap: wrap;
}

.articles {
  flex: 3;
  display: flex;
  flex-wrap: wrap;
}

.article {
  flex: 1 1 calc(50% - 20px);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin: 10px;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.article img {
  max-width: 100%;
  height: auto;
}

.article-text {
  padding: 10px;
}
.home_user_contribution_card_container {
  display: flex;
  box-shadow: var(--border-shadow);
  cursor: pointer;
  flex-direction: row;
  overflow: hidden;
  
  
  
  height: max-content;
  border-radius: 10px;
}

.card-hidden {
  display: flex;
  align-items: center;
  justify-content: center;
}

.home_user_contribution_two_image_box {
  width: 250px;
  height: 134px;
  
}

.home_user_contribution_two_details_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.home_user_contribution_two_text_container {
  width: 100%;
}
.home_user_contribution_two_text_main_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  padding: 20px;
  height: 100%;
}
.home_user_contribution_two_profile {
  font-size: 12px;
  color: #61666d;
  font-weight: 400 !important;
  font-family: "Lato";
}

.user_contribute_stories_main_container_footer {
  display: grid;
  grid-template-columns: 65% 30% !important;
  padding: 0px !important;
  width: 95%;
}

.user_contribute_stories_main_container {
  display: grid;
  grid-template-columns: 25% 40% 30%;
  height: 100%;
  
  
  column-gap: 40px;
  
  width: 95%;
}
.top_contributor_main_container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.top_contributor_container {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.top_contributor_profile {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}

.contribute_user_name,
.time-tag,
.user_contribute_publish_time {
  font-size: 10px;
  color: gray !important;
  font-weight: 400 !important;
  font-family: "Lato";
}
.home_user_contribute_second_column_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.view-count-icon,
.reading_time_icon {
  width: 10px;
}
.user_contributed_module_title {
  height: 100px;
  font-family: "Kufam";
  font-weight: 700;
}
.user_contributed_module_title_ta {
  height: 100px;
  font-family: "Kufam";
  font-weight: 700;
}
.home_user_contribution_second_card_container {
  display: flex;
  flex-direction: column;
  
  
  justify-content: space-between;
  height: 100%;
}
.home_user_contributed_story_first_column_main_container {
  display: flex;
  flex-direction: column;
  
  gap: 20px;
}
.user_contribution_mobile_card_container {
  
  border-radius: 10px !important;
  box-shadow: var(--border-shadow);
  min-height: 340px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  
}
.user_contribution_mobile_main_container {
  
  display: flex;
  flex-direction: column;
}
.user_contribution_mobile_card_image {
  width: 100%;
}

.without_padding_member_content {
  padding-top: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  
}

.home_slot_card_container {
  overflow: hidden;
  background-color: #ffffff;
  width: 30%;
}
.home_slots_background_container {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: var(--background-theme-color);
  height: 280px;
  position: absolute;
  z-index: 0;
}

.home_logo_and_container {
  display: flex;
  flex-direction: column;
  justify-content: sp;
  width: 20%;
  z-index: 1;
  height: 100%;
}

.slots_card_wrapper {
  display: flex;
  justify-content: space-between;
  
  z-index: 1;
  padding-left: 50px;
  padding-right: 70px;
}

.home_slot_and_logo_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
.home_ifcn_logo_and_content {
  display: flex;
  align-items: center;
  width: 20%;
}
.logo_content_container {
  color: white;
  display: flex;
  flex-direction: column;
  
  padding-top: 4%;
  gap: 10px;
}
.home_slot_card_image {
  object-fit: cover;
  width: 100%;
}
.home_slot_card_container:hover .home_slot_card_image {
  transform: scale(1.2) !important;
  transition: transform 0.8s ease-in-out !important;
}
.home_slot_card_container .home_slot_card_image {
  transition: transform 0.8s ease-in-out;
}
.home_slot_card_title_skeleton {
  font-weight: bold;
}
.exposing_fake_news_first_column_image {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  position: relative;
}

.exposing_fake_news_third_column_container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden !important;
}
.exposing_fake_news_image_component_container {
  height: 45%;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  overflow: hidden !important;
  position: relative !important;
}
.exposing_fake_news_image_component_container:hover .exposing_fake_news_third_column{
  transform: translateY(90px);
  overflow: hidden !important;
  transition:  0.8s ease-in;
}

.exposing_fake_news_third_column_image {
  height: 100%;
  width: 100%;
  border-radius: 11px;
  object-fit: cover;
}
.exposing_fake_news_third_column {
  background-color: #000000bf;
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 35%;
  border-radius: 0 0 10px 10px;
  padding: 2%;
}
.exposing_fake_news_third_column_first_row {
  height: 70%;
}
.exposing_fake_news_third_column_second_row {
  height: 30%;
}
.exposing_fake_news_third_column_title {
  color: #ffffff;
}
.exposing_fake_news_third_column_name {
  color: #ffffff;
}
.exposing_fake_news_second_column_sub_title {
  color: #808080 !important;
}
.exposing_fake_news_second_column_author_name {
  color: #808080 !important;
}
.exposing_fake_news_eye_icon {
  color: var(--view-icon-color);
}
.exposing_fake_news_button {
  background-color: #00adee;
  color: #ffffff;
  border-radius: 10px;
  
}
.exposing_fake_news_divider {
  border-color: #000000 !important;
}
.exposing_fake_news_divider_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.exposing_fake_news_divider_wrapper {
  width: 60%;
}
.exposing_fake_news_mobile_view_container {
  width: 100%;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  border-radius: 10px;
  display: flex !important;
}

.exposing_fake_news_mobile_view_first_col {
  width: 40%;
}
.exposing_fake_news_mobile_view_first_col_img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 10px 0 0 10px;
}
.exposing_fake_news_mobile_view_first_col :where(.css-dev-only-do-not-override-zg0ahe).ant-skeleton.ant-skeleton-element .ant-skeleton-input{
  height: 90px !important;
}
.exposing_fake_news_mobile_view_second_col {
  width: 60%;
  padding: 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.exposing_fake_news_mobile_view_wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.home_fact_check_mobile_view {
  width: 95%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.exposing_fake_news_first_column_details_mobile_view {
  background-color: rgba(20, 15, 45, 0.9) !important;
  z-index: 2;
  position: absolute;
  padding: 1%;
  width: 85%;
  margin-bottom: 2%;
}
.home_article_sec_column_inner_row_content {
  display: flex;
  flex-direction: column;
  z-index: 1;
  width: 100%;
  justify-content: flex-end;
  height: 100%;
  position: relative;
  cursor: pointer;
}

.home_article_first_column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 48% !important;
}
.home_article_card_title {
  
  width: 100% !important;
  overflow: hidden;
  
}
.home_article_card_subtitle {
  width: 100% !important;
  overflow: hidden;
  
  
}
.home_article_card_continue_read {
  width: 100% !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  
  
}

.home_donation_container {
  width: 100%;
  display: flex;
  background: var(--gradient-color) !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.home_donation_wrapper {
  width: 95%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home_donation_first_column_container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 23%;
}
.home_donation_second_column_container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 28%;
}
.home_donation_third_column_container {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  
}

.home_donation_third_column_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
  width: 90%;
}
.home_donation_fourth_column_container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14%;
}
.home_donation_first_column_wrapper {
  height: 120px;
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.home_donation_fight_against_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 95%;
}
.donation_hash_text {
  font-family: "Kufam";
  color: #f49d36;
  padding: 8px;
  font-weight: 800;
}
.donation_fight_against_text {
  font-family: "Kufam";
  color: #f49d36;
  font-weight: 800 !important;
}
.home_donation_fight_against_wrapper {
  width: 95%;
}
.home_donatio_content {
  color: white;
  padding: 20px;
}
.badge_selected {
  background-color: #00adee;
  color: white;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
}

.badge_default {
  background-color: white;
  color: black;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 45px;
  font-size: 12px;
}

.cursor_pointer {
  cursor: pointer;
}

.badge_other_selected {
  background-color: #00adee;
  color: white;
}

.home_fact_check_mobile_view_wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.exposing_fake_news_title {
  font-family: kufam;
  font-size: 20px;
}
.exposing_fake_news_secondary_title {
  font-weight: 700;
  font-family: kufam;
}

.home_user_contribution_two_title {
  
  font-family: "Lato_Bold";
  font-weight: 700;
 
}
.top_contribute_title {
  font-family: "Kufam";
  font-weight: 500;
  font-size: 25px;
}
.top_contribute_title_ta {
  font-family: "Kufam";
  font-weight: 600;
  font-size: 16px;
}
.home_user_contribution_mobile_text {
  font-weight: 600;
  font-family: "Lato";
  padding-left: 20px;
}
.home_user_contribution_image {
  width: 200px;
  object-fit: cover;
  
}
.user_home_contribution_desktop_container {
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.home_awards_section_become_member_div {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  gap: 10px;
}
.join_us_today_text {
  color: #fff;
  font-family: "Lato";
  padding-top: 10px;
  font-size: "12px";
}
.home_awards_section_become_member {
  font-family: "Kufam";
  color: #fff;
  padding-top: 10px;
  text-align: center;
  font-weight: 800;
}

.home_awards_card_image_div {
  position: relative;
  cursor: pointer;
}
.home_awards_card_image_overlay_content {
  position: absolute;
  width: 80%;
  right: 0px;
  bottom: 30px;
  background-color: #ffffff;
  align-items: center;
  display: flex;
  height: 20%;
  gap: 10px;
  padding: 10px;
}
.award_card_content_image {
  width: 10%;
}
.home_awards_card_image_overlay_text {
  font-family: "Lato";
  font-size: small;
  font-weight: 500 !important;
}
.writing_image_div {
  width: 60px;
  height: 60px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  background-color: #0065cc;
  box-shadow: 4px 4px 10px rgba(20, 15, 45, 0.3);
  border-radius: 30px;
  z-index: 99;
  cursor: pointer;
}


.writing_image {
  width: 100%;
}

.scroll_to_top_icon_div {
  width: 40px;
  height: 40px;
  position: fixed;
  right: 20px;
  bottom: 10px;
  background-color: #0065cc;
  box-shadow: 4px 4px 10px rgba(20, 15, 45, 0.3);
  border-radius: 20px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.scroll_to_top_icon {
  color: #fff;
  font-size: 20px;
}
.exposing_fake_news_button_mobile {
  background-color: #00adee;
  color: #ffffff;
  border-radius: 10px;
  
}
.exposing_fake_news_button_mobile_container {
  width: 100%;
  justify-content: center;
  display: flex;
  padding-bottom: 5%;
}
.badge_other_default {
  background-color: white;
  color: black;
}
.home_amount_wrapper {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.home_donate_button {
  background-color: #00adee;
  color: white;
}
.donate_amt_content_text {
  color: white;
}

.home_slot_card_views {
  color: red;
}
.views_container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.home_slot_card_views {
  color: red;
}
.views_container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.home_slots_content_container {
  width: 100%;
  
  position: relative;
}
.home_page_slots_top_container {
  width: 100%;
  height: 160px;
  background: linear-gradient(180deg, #140f2d, #140f2d, transparent);
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 20px;
  padding-bottom: 30px;
  padding-top: 30px;
}
.youturn_presents_title,
.featured_stories_title {
  color: #fff !important;
}
.youturn_presents_title {
  font-size: 15px !important;
}

._views {
  color: #ffffff;
  font-size: 13px;
  color: white;
  font-weight: bold;
}
.home_slot_card_views {
  color: red;
}
.views_container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.youturn_presents_title,
.featured_stories_title {
  color: #fff !important;
}
.youturn_presents_title {
  font-size: 15px !important;
}
.featured_stories_title {
}
.hide_content_in_desktop {
  margin-bottom: 30px;
  position: relative;
}
.home_videos_second_column_overlay_play_button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home_video_thumbnail_container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.donate_inr_text {
  color: gray;
}
.home_donation_input_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
}

.back_button {
  background: linear-gradient(
    166.4deg,
    #140f2d 9.74%,
    #f49d36 281.54%
  ) !important;
  color: white;
}

.home_article_trending_image {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  border-radius: 8px 8px 8px 8px !important;
}

.home_donation_input {
  width: 100%;
  height: 100%;
}
.user_details_submit_button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 20px;
}
.user_detail_mobile_no_input {
  width: 100%;
}
.submit_button {
  background-color: #00acee;
  color: white;
  height: auto;
}

.submit_button:hover {
  background-color: #00acee !important;
  color: white !important;
}
.home_donate_button_disabled {
  background-color: #140f2d !important;
  color: gray !important;
  cursor: not-allowed !important;
  border: none;
  opacity: 1;
}
.thank_you_modal_content {
  text-align: center;
}

.thank_you_image {
  border-radius: 9px;
  z-index: 1;
  object-fit: cover;
  height: 170px;
  margin-top: 4vh;
}

.thank_you_message {
  margin-top: 4vh;
}
.home_article_card_author_name_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: "Lato";
  
  font-size: 15px !important;
}
.featured_stories_title {
  font-weight: 700;
  font-family: "Lato";
  
}

.slot_card_details {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 10px;
  
}
.fact_check_first_column_card_container {
  background-color: #fff !important;
  box-shadow: var(--border-shadow);
  display: flex;
  flex-direction: column;
  z-index: 1;
  
  overflow: hidden;
  cursor: pointer;
  border-radius: 0px 0px 10px 10px;
}
.slot_main_container {
  width: 24%;
  background-color: #fff !important;
  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  display: flex;
  flex-direction: column;
  z-index: 1;
  margin-bottom: 50px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 0px 0px 10px 10px;
  justify-content: space-between;
}
body.dark_mode .slot_main_container{
  background-color: #2d2d2d !important;
}
.slot_image_box {
  width: 100%;
  height: 170px;
  object-fit: cover;
}
.slot_card_title {
  font-family: "Lato";
  font-size: 14px;
  font-weight: 700 !important;
}
.slot_card_title_en {
  font-family: "Lato";
  font-size: 14px;
  font-weight: 700 !important;
}
.slot_card_sub_title {
  font-size: 11px;
  color: var(--subtitle-color);
  height: 130px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  font-family: "Lato";
}
.slot_card_footer_content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.home_slot_description {
  font-size: 12px;
}
.home_slot_title {
  font-size: 28px;
}
.home_slot_youturn_present_title {
  font-size: 10px;
}
.home_slots_background_image_container {
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: flex-start;
  width: 100%;
  margin-top: 280px;
  padding-left: 50px;
}
.slot_card_sub_title_en {
  text-align: justify;
  color: #61666d;
  margin-bottom: 5px;
  margin-top: 5px;
  overflow: hidden;
}
.slot_image {
  width: 100%;
  height: 100%;
}

.slot_main_container:hover > .image_hover_effect {
  transform: var(--image-hover-transform);
  transition: var(--image-hover-transition);
}
.home_slot_mobile_image {
  height: 100%;
  object-fit: contain;
  width: 100%;
}
.home_slot_mobile_image_box {
  width: 100%;
  max-height: 500px;
  object-fit: contain;
}
.home_slot_mobile_carousel_container {
  margin-top: 20%;
}
.margin_zero {
  margin: 0px !important;
}
.width-100 {
  width: 100% !important;
}
.home_slot_card_author_detail {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  
}
.slot_card_title_container {
  overflow: hidden;
  overflow: hidden;
  font-family: "Kufam";
  font-weight: 600;
}
.continue_reading_container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.user_contributed_story_container_footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: auto;
}
.home_slot_view_time_wrapper {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.slot_card_subtitle_container {
  overflow: hidden;
}
.slot_card_subtitle_container,
.slot_card_subtitle_container_ta {
  overflow: hidden;
  color: gray;
}
.home_slot_card_author_name {
  font-weight: 400;
}
.fact_check_first_column_card_container:hover > .image_hover_effect {
  transform: var(--image-hover-transform);
  transition: var(--image-hover-transition);
}

.home_article_trending_container_skeleton {
  width: 100% !important;
  border-radius: 8px;
  display: flex !important;
  flex-direction: column;
  justify-content: flex-end !important;
  position: relative;
}

.home_article_sec_column_inner_row_content_skeleton {
  width: 100% !important;
  height: 200px !important;
}
.exposing_fake_news_first_column_image_skeleton {
  width: 100% !important;
  height: 100% !important;
}
.fact_check_first_column_card_container_loading {
  background-color: #fff !important;
  box-shadow: var(--border-shadow);
  display: flex;
  flex-direction: column;
  z-index: 1;
  
  overflow: hidden;
  cursor: pointer;
  border-radius: 0px 0px 10px 10px;
  height: 100%;
}
.home_trending_author_text {
  color: white;
  font-family: "Lato";
}
.exposing_fake_news_second_column_image_skeleton {
  width: 100% !important;
  height: 150px !important;
}
.home_trending_title_text_en {
  color: white;
  font-family: "Lato";
  font-weight: 800;
}
.exposing_fake_news_first_column_title_ta {
  color: #ffffff;
}

.exposing_fake_news_third_skeleton {
  display: flex !important;
  gap: 5px !important;
  width: 100%;
}
.zoom-effect {
  overflow: hidden;
  position: relative;
}
.slot_main_container:hover > .zoom-effect img {
  transform: scale(1.1);
  transition: transform 0.8s ease-in-out;
}

.home_user_contribution_card_container:hover
  > .home_user_contribution_image
  img {
  transform: scale(1.1);
  transition: transform 0.8s ease-in-out;
}
.home_user_contribution_card_container:not(:hover)
  > .home_user_contribution_image
  img {
  transition: transform 0.9s ease-in-out; 
}
.slot_main_container:not(:hover) > .zoom-effect img {
  transition: transform 0.9s ease-in-out; 
}

.home_user_contribution_vertical_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.home_user_contribution_second_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  width: 60%;
}
.home_videos_title_text_ta {
  color: #fff;
  text-align: left;
  font-family: "Kufam";
}
.home_page_videos_text_content_ta {
  color: #fff;
  font-size: large;
  width: 100%;
}
.submit_claim_form {
  padding: 15px 15px 0px 15px;
}
.thank_you_modal_content_main_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 400px;
}
.badge_selected:hover {
  background-color: #00adee !important;
  color: white !important;
  border: none !important;
}

.user_contribution_mobile_title_and_top_contributors {
  padding: 0 0 0 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.home_article_title_container {
  gap: 20px;
}
.donation_amount_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.home_amount_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.home_donation_third_column_division {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;
}
.writing_image_div,
.scroll_to_top_icon_div {
  transition: opacity 2s ease-in-out !important;
}

.bell_image {
  width: 60px;
  height: 60px;
  position: fixed;
  left: 80px;
  bottom: 10px;
  background-color: #0065cc;
  box-shadow: 4px 4px 10px rgba(20, 15, 45, 0.3);
  border-radius: 50%; 
  z-index: 99;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center; 
}

.bell_icon {
  width: 30px; 
  height: 30px;
}

.bell_image,
.scroll_to_top_icon_div {
  transition: opacity 2s ease-in-out !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,sBAAsB;EACtB,oDAAoD;EACpD,UAAU;EACV,QAAQ;EACR,4BAA4B;EAC5B,UAAU;EACV,uBAAuB;AACzB;;;AAGA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;;AAGA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gDAAgD;EAChD,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;;EAExB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,+CAA+C;EAC/C,uBAAuB;AACzB;AACA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;AACA;EACE,+DAA+D;EAC/D,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,YAAY;;EAEZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,oDAAoD;EACpD,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kDAAkD;EAClD,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,qCAAqC;EACrC,SAAS;;AAEX;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;;EAEb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,uEAAuE;EACvE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;;;;EAIhB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;;;EAGZ,gBAAgB;;EAEhB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;;;EAGtB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;;EAEtB,SAAS;AACX;AACA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;;AAGlB;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;;AAE/B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,+CAA+C;EAC/C,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;;EAE9B,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;;EAEtB,eAAe;EACf,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,iDAAiD;AACnD;AACA;EACE,sCAAsC;AACxC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;;AAErB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,oDAAoD;EACpD,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kDAAkD;EAClD,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;;EAEE,sBAAsB;EACtB,gBAAgB;;AAElB;AACA;EACE,sBAAsB;EACtB,gBAAgB;;;AAGlB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;;AAGrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4CAA4C;EAC5C,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;;AAElB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;;AAEnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,SAAS;EACT,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;;AAErB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;;EAEX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,kEAAkE;EAClE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;AACA;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;;;;cAIY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;;EAEnB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,SAAS;;AAEX;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,UAAU;;EAEV,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,iCAAiC;EACjC,oDAAoD;EACpD,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;;AAErB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,UAAU;;EAEV,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;;;EAGE,qBAAqB;EACrB,sCAAsC;AACxC;AACA;;;EAGE,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;AACA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,6CAA6C;AAC/C","sourcesContent":[".home_article_card_skeleton_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  border-radius: 5px;\n}\n.home_article_first_card_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  cursor: pointer;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  width: 95% !important;\n}\n\n.home_article_card_details_skeleton_wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n.home_article_card_details_wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding: 7px;\n  width: 45% !important;\n}\n\n.home_article_card_skeleton_author_details_wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n.home_article_card_author_details_wrapper {\n  display: flex;\n  justify-content: space-between;\n  width: 100% !important;\n}\n.home_article_card_author_details_container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.ant-skeleton.ant-skeleton-element .ant-skeleton-input {\n  min-width: 0px;\n}\n.home_articles_container {\n  width: 100%;\n  height: 400px;\n}\n\n.fact_check_middle_card_skeleton_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n.home_article_card_skeleton_author_details_wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.ant-skeleton.ant-skeleton-element .ant-skeleton-input {\n  min-width: 0px;\n}\n.home_articles_container {\n  width: 100%;\n  height: 400px;\n}\n\n.fact_check_middle_card_container {\n  height: 400px;\n}\n\n.exposing_fake_news_second_section {\n  display: flex;\n  justify-content: space-between !important;\n  flex-direction: column;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  width: 25%;\n  gap: 5px;\n  border-radius: 0 0 10px 10px;\n  z-index: 1;\n  background-color: white;\n}\n\n\n.fact_check_middle_card_image {\n  width: 100% !important;\n  width: 25%;\n}\n\n.exposing_fake_news_wrapper {\n  width: 90%;\n  justify-content: space-between;\n  height: 100%;\n}\n.exposing_fake_news_second_column_image {\n  width: 100% !important;\n}\n\n.fact_check_middle_card_title_wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 0 4% 0 4%;\n}\n\n.fact_check_middle_card_sub_title_wrapper {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 0 4% 0 4%;\n}\n.fact_check_middle_card_title_skeleton {\n  width: 100% !important;\n}\n.fact_check_middle_card_sub_title_skeleton {\n  width: 100% !important;\n}\n\n\n.exposing_fake_news_details_skeleton {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n}\n\n.fact_check_middle_card_sub_title_container {\n  padding: 0 4% 0 4%;\n  overflow: hidden;\n}\n.fact_check_middle_card_details_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 4% 0 4%;\n}\n.fact_check_middle_card_details_wrapper {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.fact_check_middle_card_details {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.fact_check_middle_card_title_container {\n  padding: 0 4% 0 4%;\n}\n\n.fact_check_continue_reading {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #0d99ff;\n  font-size: 12px;\n}\n\n.home_slot_card_views_wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n.home_article_first_column_container {\n  display: flex;\n  justify-content: center;\n}\n.home_article_first_column_wrapper {\n  display: flex;\n  flex-direction: row;\n  width: 90%;\n}\n.home_article_card_thumbnail_container {\n  border-radius: 5px 0px 0px 5px;\n  object-fit: cover !important;\n  width: 55% !important;\n}\n.home_article_second_column {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 52%;\n}\n.home_article_title_text {\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n}\n\n.title_text {\n  font-weight: bold;\n}\n.sub_title_text {\n  color: gray;\n}\n.home_article_row_container {\n  width: 100% !important;\n  display: flex;\n  justify-content: center;\n}\n.home_article_row_wrapper {\n  height: 100% !important;\n  width: 90%;\n  display: flex;\n  justify-content: space-between;\n}\n.home_article_trending_container {\n  width: 24%;\n  border-radius: 8px;\n  z-index: 1;\n  display: flex !important;\n  flex-direction: column;\n  justify-content: flex-end !important;\n  position: relative;\n  cursor: pointer !important;\n  overflow: hidden !important;\n}\n.home_article_trending_container:hover .home_article_trending_details_container {\n  overflow: hidden !important;\n  transform: translateY(60px); \n}\n\n.related_fact_check_card {\n  border-radius: 8px;\n  z-index: 1;\n  display: flex !important;\n  flex-direction: column;\n  justify-content: flex-end !important;\n  position: relative;\n  cursor: pointer !important;\n  overflow: hidden !important;\n}\n.related_fact_check_card:hover .home_article_trending_details_container{\n  transform: translateY(60px) !important;\n  overflow: hidden !important;\n}\n\n.home_article_trending_details_container {\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.75) !important;\n  z-index: 2;\n  position: absolute;\n  border-radius: 0px 0px 7px 7px;\n  padding: 5px;\n  gap: 3px !important;\n  min-height: 30%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: 0.6s ease-in; \n\n  overflow: hidden !important;\n}\n.home_article_trending_title_container {\n  width: 100%;\n  overflow: hidden;\n}\n.home_article_trending_author_container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n}\n.home_trending_title_text {\n  color: white;\n  font-family: kufam;\n  font-weight: 600;\n}\n.home_article_trending_thumbnail {\n  border-radius: 8px 0px 0px 8px !important;\n  object-fit: cover;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.home_article_card_author_details {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.view_icon {\n  padding-right: 3px !important;\n  color: var(--view-icon-color);\n}\n.is_red {\n  color: var(--view-icon-color);\n}\n.reading_icon {\n  padding-right: 3px !important;\n  color: gray;\n}\n\n.home_article_author_view_container {\n  display: flex;\n  justify-content: center;\n}\n.home_article_card_time_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.exposing_fake_news_details_skeleton {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n}\n\n.exposing_fake_news_second_column_sub_title_container {\n  padding: 0 4% 0 4%;\n  overflow: hidden;\n}\n.exposing_fake_news_second_column_details_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 4% 0 4%;\n}\n.exposing_fake_news_second_column_details_wrapper {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.exposing_fake_news_second_column_details {\n  display: flex;\n  align-items: center;\n  color: #808080 !important;\n  gap: 5px;\n}\n.exposing_fake_news_second_column_title_container {\n  padding: 0 4% 0 4%;\n}\n.fact_check_continue_reading_wrapper {\n  padding: 0 4% 2% 4%;\n  display: flex;\n  align-items: center;\n}\n.fact_check_continue_reading {\n  cursor: pointer;\n  text-decoration: underline;\n  color: #0d99ff;\n}\n\n.home_slot_card_views_wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n.user-contributed-background-theme {\n  background-color: var(--background-theme-color);\n  color: white !important;\n}\n.member-button {\n  background-color: var(--become-member-button);\n  color: white !important;\n}\n.border-shadow {\n  box-shadow: rgba(0, 101, 204, 0.1) 0px 0px 10px 10px !important;\n  border: 0px solid white !important;\n}\n\n.h-10 {\n  height: 10% !important;\n}\n.w-10 {\n  width: 10%;\n}\n.radius-50 {\n  border-radius: 50%;\n}\n.view-count-tag {\n  color: var(--view-icon-color);\n  font-size: 10px;\n}\n.time-tag {\n  color: gray;\n}\n.user_contributed_story_container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 1px 1px 10px 10px;\n  height: 620px;\n}\n.home_user_contribute_title {\n  font-size: 14px;\n  font-weight: 700;\n  font-family: \"Lato_Bold\";\n}\n.home_user_contribute_mobile_title {\n  font-size: 12px;\n  font-family: \"Lato\";\n  font-weight: 600;\n}\n\n.user_contributed_story_container_image {\n  height: 150px;\n  object-fit: fill;\n}\n\n.user_contributed_story_text_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 10px;\n  height: 100%;\n  gap: 20px;\n}\n.home_user_contribute_subtitle {\n  font-size: 10px;\n  color: #61666d;\n  font-family: \"Lato\";\n  font-weight: 500px;\n  line-height: 16px;\n}\n.display_flex {\n  display: flex !important;\n}\n.flex_direction_row {\n  flex-direction: row !important;\n}\n.justify-content-between {\n  justify-content: space-between !important;\n}\n.align-center {\n  align-items: center !important;\n}\n.gap_10 {\n  gap: 5px !important;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n.continue_reading_text {\n  color: #0d99ff;\n  text-decoration: underline;\n  font-weight: 600;\n  cursor: pointer;\n}\n.continue_reading_text_ta {\n  color: #0d99ff;\n  text-decoration: underline;\n  font-weight: 600;\n  cursor: pointer;\n}\n.contribute_user_name {\n  color: gray;\n}\n\n.home_user_contribute_container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.user_contribution_mobile_card_footer,\n.home_user_contribute_mobile_title {\n  padding: 10px;\n}\n\n.user_contributed_story_column_container {\n  background-color: var(--background-theme-color);\n  height: 100%;\n  \n  display: flex;\n  flex-direction: column;\n  border-radius: 20px;\n}\n.user_contributed_story_column_box {\n  height: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.empower_truth_tag {\n  color: var(--tag-color);\n  font-weight: 600;\n  font-family: \"Kufam\";\n}\n.become_a_member_button {\n  background-color: #0d99ff;\n  color: white;\n  border: 1px solid #0d99ff !important;\n}\n.become_member_content {\n  font-size: 20px;\n  color: white;\n  font-weight: 400 !important;\n  font-family: \"Lato\";\n}\n.become_member_content_ta {\n  font-size: 20px;\n  color: white;\n  font-weight: 500 !important;\n  font-family: \"Lato\";\n}\n\n.exposing_fake_news_container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n}\n.inner_row_content {\n  display: flex;\n  flex-direction: column;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  z-index: 1;\n  width: 100%;\n  justify-content: flex-end;\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n  overflow: hidden !important;\n}\n\n.exposing_fake_news_first_column_details {\n  background-color: rgba(20, 15, 45, 0.9) !important;\n  z-index: 2;\n  position: absolute;\n  padding: 1%;\n  margin-bottom: 2%;\n  width: 80%;\n}\n\n.home_article_second_column_details {\n  background-color: rgba(20, 15, 45, 0.9) !important;\n  z-index: 2;\n  position: absolute;\n  padding: 1%;\n  width: 80%;\n  margin-bottom: 2%;\n}\n.exposing_fake_news_first_column_view_count {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.exposing_fake_news_first_column_view_icon {\n  color: white;\n}\n.exposing_fake_news_first_column_button {\n  background-color: #140f2d !important;\n  color: #ffffff !important;\n  border-radius: 10px;\n  border: 1px solid white !important;\n}\n.exposing_fake_news_first_column_details_wrapper {\n  height: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.exposing_fake_news_first_column_details_row {\n  height: 55%;\n  display: flex;\n  align-items: center;\n}\n.exposing_fake_news_first_column_title {\n  color: #ffffff;\n}\n.exposing_fake_news_first_column_writer_name_and_views {\n  color: #ffffff;\n}\n.home_article_second_column_writer_name_and_views {\n  color: #ffffff;\n}\n.exposing_fake_news_first_column_details_skeleton {\n  z-index: 2;\n  position: absolute;\n  padding: 1%;\n}\n\n.exposing_fake_news_first_section {\n  width: 45%;\n}\n.exposing_fake_news_third_section {\n  width: 25%;\n}\n.home_videos_section {\n  display: flex;\n  background-color: #140f2d;\n  width: 100%;\n  margin: 0 auto;\n  justify-content: center;\n  padding-top: 50px;\n}\n.home_videos_first_column {\n  width: 45%;\n}\n.home_videos_second_column {\n  width: 45%;\n  display: flex;\n  justify-content: flex-end;\n}\n.home_videos_second_column_contents {\n  width: 90%;\n  display: grid;\n  justify-content: flex-end;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  \n}\n.home_videos_title {\n  width: 50%;\n}\n.home_videos_title_text {\n  color: #fff;\n  text-align: left;\n  font-family: \"Kufam\";\n}\n.see_all_btn {\n  background-color: transparent;\n  border: 1px solid white;\n  color: #fff;\n}\n.home_videos_title_row {\n  display: flex;\n  flex-direction: row;\n  \n}\n.see_all_btn_position {\n  display: flex;\n  justify-content: flex-end;\n  width: 50%;\n}\n.home_page_videos_text_content {\n  color: #fff;\n  font-size: large;\n  width: 100%;\n}\n.home_page_videos_thumbnail {\n  width: 100% !important;\n  object-fit: cover;\n  border-radius: 10px;\n}\n.home_page_videos_thumbnail_div {\n  width: 100%;\n  position: relative;\n  cursor: pointer;\n}\n.home_videos_thumbnail_overlay_content {\n  position: absolute;\n  bottom: 20px;\n  background-color: #ffffffcc;\n  color: #fff;\n  width: 60%;\n  height: 80px;\n  display: flex;\n  \n  justify-content: center;\n}\n\n.home_videos_subscribe_button {\n  background-color: #ef1d26;\n  color: #fff;\n  border-radius: 10px;\n  width: 50%;\n  height: 40px;\n  align-items: center;\n  justify-content: space-around;\n  display: flex;\n  cursor: pointer;\n}\n.home_videos_subscribe_button_image {\n  width: 20px;\n}\n.home_videos_subscribe_button_position {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n}\n.home_videos_thumbnail_overlay_play_icon {\n  width: 50px;\n  margin-left: 5px;\n}\n.home_videos_thumbnail_overlay_content_row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.home_videos_thumbnail_overlay_text {\n  color: #111;\n  font-size: 14px;\n}\n.home_videos_thumbnail_overlay_viewed_text {\n  font-size: 12px;\n  color: #111;\n}\n.home_page_overlay_text_column {\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n}\n.home_videos_second_column_image {\n  width: 95%;\n  border: 1.5px solid rgb(231, 231, 231);\n  border-radius: 10px;\n  object-fit: \"cover\";\n  align-items: center;\n  height: auto;\n}\n.home_videos_viewed_count_and_published {\n  font-family: \"Lato_Bold\";\n  color: #fff;\n  font-size: 12px;\n}\n.home_videos_viewed_count_and_published_div {\n  display: flex;\n  width: 90%;\n  margin-bottom: 10px;\n}\n.home_videos_mobile_view_contents {\n  display: grid;\n  grid-template-columns: 1fr;\n  row-gap: 20px; \n  padding: 10px;\n  background-color: #140f2d;\n}\n\n.home_videos_mobile_view_item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.home_videos_mobile_view_image {\n  width: 90%;\n  border: 1.5px solid rgb(231, 231, 231);\n  border-radius: 10px;\n  object-fit: cover;\n  cursor: pointer;\n}\n.home_videos_section_mobile_view {\n  background-color: #140f2d;\n}\n.home_page_videos_text_content_mobile_view {\n  color: #fff;\n  font-size: large;\n  width: 100%;\n  padding-top: 10px;\n}\n.home_awards_section {\n  background: linear-gradient(147.32deg, #140f2d 40.85%, #f49d36 169.52%);\n  width: 100%;\n  /* height: 100%; */\n}\n.home_awards_section_title {\n  font-family: \"Kufam\";\n  color: #fff;\n  font-size: 24px;\n  margin-bottom: 20px;\n  padding-top: 50px;\n  padding-bottom: 20px;\n  padding-left: 20px;\n}\n.home_awards_card_image {\n  width: 100%;\n  border-radius: 10px;\n  border: 2px solid rgba(255, 255, 255, 0.905);\n  opacity: 0.8;\n}\n.home_awards_card_div {\n  display: flex;\n  flex-direction: column;\n  margin: 0 20px;\n}\n\nbody {\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.header h1,\n.header h2 {\n  margin: 0;\n}\n\n.content {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.articles {\n  flex: 3;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.article {\n  flex: 1 1 calc(50% - 20px);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  margin: 10px;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n}\n\n.article img {\n  max-width: 100%;\n  height: auto;\n}\n\n.article-text {\n  padding: 10px;\n}\n.home_user_contribution_card_container {\n  display: flex;\n  box-shadow: var(--border-shadow);\n  cursor: pointer;\n  flex-direction: row;\n  overflow: hidden;\n  \n  \n  \n  height: max-content;\n  border-radius: 10px;\n}\n\n.card-hidden {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.home_user_contribution_two_image_box {\n  width: 250px;\n  height: 134px;\n  \n}\n\n.home_user_contribution_two_details_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.home_user_contribution_two_text_container {\n  width: 100%;\n}\n.home_user_contribution_two_text_main_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 20px;\n  height: 100%;\n}\n.home_user_contribution_two_profile {\n  font-size: 12px;\n  color: #61666d;\n  font-weight: 400 !important;\n  font-family: \"Lato\";\n}\n\n.user_contribute_stories_main_container_footer {\n  display: grid;\n  grid-template-columns: 65% 30% !important;\n  padding: 0px !important;\n  width: 95%;\n}\n\n.user_contribute_stories_main_container {\n  display: grid;\n  grid-template-columns: 25% 40% 30%;\n  height: 100%;\n  \n  \n  column-gap: 40px;\n  \n  width: 95%;\n}\n.top_contributor_main_container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.top_contributor_container {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n}\n.top_contributor_profile {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.contribute_user_name,\n.time-tag,\n.user_contribute_publish_time {\n  font-size: 10px;\n  color: gray !important;\n  font-weight: 400 !important;\n  font-family: \"Lato\";\n}\n.home_user_contribute_second_column_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.view-count-icon,\n.reading_time_icon {\n  width: 10px;\n}\n.user_contributed_module_title {\n  height: 100px;\n  font-family: \"Kufam\";\n  font-weight: 700;\n}\n.user_contributed_module_title_ta {\n  height: 100px;\n  font-family: \"Kufam\";\n  font-weight: 700;\n}\n.home_user_contribution_second_card_container {\n  display: flex;\n  flex-direction: column;\n  \n  \n  justify-content: space-between;\n  height: 100%;\n}\n.home_user_contributed_story_first_column_main_container {\n  display: flex;\n  flex-direction: column;\n  \n  gap: 20px;\n}\n.user_contribution_mobile_card_container {\n  \n  border-radius: 10px !important;\n  box-shadow: var(--border-shadow);\n  min-height: 340px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  \n  \n}\n.user_contribution_mobile_main_container {\n  \n  display: flex;\n  flex-direction: column;\n}\n.user_contribution_mobile_card_image {\n  width: 100%;\n}\n\n.without_padding_member_content {\n  padding-top: 0px !important;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  \n}\n\n.home_slot_card_container {\n  overflow: hidden;\n  background-color: #ffffff;\n  width: 30%;\n}\n.home_slots_background_container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  background-color: var(--background-theme-color);\n  height: 280px;\n  position: absolute;\n  z-index: 0;\n}\n\n.home_logo_and_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: sp;\n  width: 20%;\n  z-index: 1;\n  height: 100%;\n}\n\n.slots_card_wrapper {\n  display: flex;\n  justify-content: space-between;\n  \n  z-index: 1;\n  padding-left: 50px;\n  padding-right: 70px;\n}\n\n.home_slot_and_logo_wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n.home_ifcn_logo_and_content {\n  display: flex;\n  align-items: center;\n  width: 20%;\n}\n.logo_content_container {\n  color: white;\n  display: flex;\n  flex-direction: column;\n  \n  padding-top: 4%;\n  gap: 10px;\n}\n.home_slot_card_image {\n  object-fit: cover;\n  width: 100%;\n}\n.home_slot_card_container:hover .home_slot_card_image {\n  transform: scale(1.2) !important;\n  transition: transform 0.8s ease-in-out !important;\n}\n.home_slot_card_container .home_slot_card_image {\n  transition: transform 0.8s ease-in-out;\n}\n.home_slot_card_title_skeleton {\n  font-weight: bold;\n}\n.exposing_fake_news_first_column_image {\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  object-fit: cover;\n  position: relative;\n}\n\n.exposing_fake_news_third_column_container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  cursor: pointer;\n  overflow: hidden !important;\n}\n.exposing_fake_news_image_component_container {\n  height: 45%;\n  width: 100%;\n  z-index: 1;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n  overflow: hidden !important;\n  position: relative !important;\n}\n.exposing_fake_news_image_component_container:hover .exposing_fake_news_third_column{\n  transform: translateY(90px);\n  overflow: hidden !important;\n  transition:  0.8s ease-in;\n}\n\n.exposing_fake_news_third_column_image {\n  height: 100%;\n  width: 100%;\n  border-radius: 11px;\n  object-fit: cover;\n}\n.exposing_fake_news_third_column {\n  background-color: #000000bf;\n  z-index: 2;\n  position: absolute;\n  width: 100%;\n  height: 35%;\n  border-radius: 0 0 10px 10px;\n  padding: 2%;\n}\n.exposing_fake_news_third_column_first_row {\n  height: 70%;\n}\n.exposing_fake_news_third_column_second_row {\n  height: 30%;\n}\n.exposing_fake_news_third_column_title {\n  color: #ffffff;\n}\n.exposing_fake_news_third_column_name {\n  color: #ffffff;\n}\n.exposing_fake_news_second_column_sub_title {\n  color: #808080 !important;\n}\n.exposing_fake_news_second_column_author_name {\n  color: #808080 !important;\n}\n.exposing_fake_news_eye_icon {\n  color: var(--view-icon-color);\n}\n.exposing_fake_news_button {\n  background-color: #00adee;\n  color: #ffffff;\n  border-radius: 10px;\n  \n}\n.exposing_fake_news_divider {\n  border-color: #000000 !important;\n}\n.exposing_fake_news_divider_container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.exposing_fake_news_divider_wrapper {\n  width: 60%;\n}\n.exposing_fake_news_mobile_view_container {\n  width: 100%;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  border-radius: 10px;\n  display: flex !important;\n}\n\n.exposing_fake_news_mobile_view_first_col {\n  width: 40%;\n}\n.exposing_fake_news_mobile_view_first_col_img {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  border-radius: 10px 0 0 10px;\n}\n.exposing_fake_news_mobile_view_first_col :where(.css-dev-only-do-not-override-zg0ahe).ant-skeleton.ant-skeleton-element .ant-skeleton-input{\n  height: 90px !important;\n}\n.exposing_fake_news_mobile_view_second_col {\n  width: 60%;\n  padding: 2%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.exposing_fake_news_mobile_view_wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.home_fact_check_mobile_view {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.exposing_fake_news_first_column_details_mobile_view {\n  background-color: rgba(20, 15, 45, 0.9) !important;\n  z-index: 2;\n  position: absolute;\n  padding: 1%;\n  width: 85%;\n  margin-bottom: 2%;\n}\n.home_article_sec_column_inner_row_content {\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  width: 100%;\n  justify-content: flex-end;\n  height: 100%;\n  position: relative;\n  cursor: pointer;\n}\n\n.home_article_first_column {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 48% !important;\n}\n.home_article_card_title {\n  \n  width: 100% !important;\n  overflow: hidden;\n  \n}\n.home_article_card_subtitle {\n  width: 100% !important;\n  overflow: hidden;\n  \n  \n}\n.home_article_card_continue_read {\n  width: 100% !important;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  \n  \n}\n\n.home_donation_container {\n  width: 100%;\n  display: flex;\n  background: var(--gradient-color) !important;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.home_donation_wrapper {\n  width: 95%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.home_donation_first_column_container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 23%;\n}\n.home_donation_second_column_container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 28%;\n}\n.home_donation_third_column_container {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  \n}\n\n.home_donation_third_column_wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 15px;\n  width: 90%;\n}\n.home_donation_fourth_column_container {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 14%;\n}\n.home_donation_first_column_wrapper {\n  height: 120px;\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.home_donation_fight_against_wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  width: 95%;\n}\n.donation_hash_text {\n  font-family: \"Kufam\";\n  color: #f49d36;\n  padding: 8px;\n  font-weight: 800;\n}\n.donation_fight_against_text {\n  font-family: \"Kufam\";\n  color: #f49d36;\n  font-weight: 800 !important;\n}\n.home_donation_fight_against_wrapper {\n  width: 95%;\n}\n.home_donatio_content {\n  color: white;\n  padding: 20px;\n}\n.badge_selected {\n  background-color: #00adee;\n  color: white;\n  border-radius: 10px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none !important;\n}\n\n.badge_default {\n  background-color: white;\n  color: black;\n  border-radius: 10px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 25px;\n  width: 45px;\n  font-size: 12px;\n}\n\n.cursor_pointer {\n  cursor: pointer;\n}\n\n.badge_other_selected {\n  background-color: #00adee;\n  color: white;\n}\n\n.home_fact_check_mobile_view_wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n.exposing_fake_news_title {\n  font-family: kufam;\n  font-size: 20px;\n}\n.exposing_fake_news_secondary_title {\n  font-weight: 700;\n  font-family: kufam;\n}\n\n.home_user_contribution_two_title {\n  \n  font-family: \"Lato_Bold\";\n  font-weight: 700;\n \n}\n.top_contribute_title {\n  font-family: \"Kufam\";\n  font-weight: 500;\n  font-size: 25px;\n}\n.top_contribute_title_ta {\n  font-family: \"Kufam\";\n  font-weight: 600;\n  font-size: 16px;\n}\n.home_user_contribution_mobile_text {\n  font-weight: 600;\n  font-family: \"Lato\";\n  padding-left: 20px;\n}\n.home_user_contribution_image {\n  width: 200px;\n  object-fit: cover;\n  \n}\n.user_home_contribution_desktop_container {\n  padding-left: 40px;\n  padding-right: 40px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.home_awards_section_become_member_div {\n  display: flex;\n  justify-content: center;\n  padding-bottom: 20px;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 30px;\n  gap: 10px;\n}\n.join_us_today_text {\n  color: #fff;\n  font-family: \"Lato\";\n  padding-top: 10px;\n  font-size: \"12px\";\n}\n.home_awards_section_become_member {\n  font-family: \"Kufam\";\n  color: #fff;\n  padding-top: 10px;\n  text-align: center;\n  font-weight: 800;\n}\n\n.home_awards_card_image_div {\n  position: relative;\n  cursor: pointer;\n}\n.home_awards_card_image_overlay_content {\n  position: absolute;\n  width: 80%;\n  right: 0px;\n  bottom: 30px;\n  background-color: #ffffff;\n  align-items: center;\n  display: flex;\n  height: 20%;\n  gap: 10px;\n  padding: 10px;\n}\n.award_card_content_image {\n  width: 10%;\n}\n.home_awards_card_image_overlay_text {\n  font-family: \"Lato\";\n  font-size: small;\n  font-weight: 500 !important;\n}\n.writing_image_div {\n  width: 60px;\n  height: 60px;\n  position: fixed;\n  left: 10px;\n  bottom: 10px;\n  background-color: #0065cc;\n  box-shadow: 4px 4px 10px rgba(20, 15, 45, 0.3);\n  border-radius: 30px;\n  z-index: 99;\n  cursor: pointer;\n}\n\n\n.writing_image {\n  width: 100%;\n}\n\n.scroll_to_top_icon_div {\n  width: 40px;\n  height: 40px;\n  position: fixed;\n  right: 20px;\n  bottom: 10px;\n  background-color: #0065cc;\n  box-shadow: 4px 4px 10px rgba(20, 15, 45, 0.3);\n  border-radius: 20px;\n  z-index: 99;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.scroll_to_top_icon {\n  color: #fff;\n  font-size: 20px;\n}\n.exposing_fake_news_button_mobile {\n  background-color: #00adee;\n  color: #ffffff;\n  border-radius: 10px;\n  \n}\n.exposing_fake_news_button_mobile_container {\n  width: 100%;\n  justify-content: center;\n  display: flex;\n  padding-bottom: 5%;\n}\n.badge_other_default {\n  background-color: white;\n  color: black;\n}\n.home_amount_wrapper {\n  width: 90%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.home_donate_button {\n  background-color: #00adee;\n  color: white;\n}\n.donate_amt_content_text {\n  color: white;\n}\n\n.home_slot_card_views {\n  color: red;\n}\n.views_container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.home_slot_card_views {\n  color: red;\n}\n.views_container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.home_slots_content_container {\n  width: 100%;\n  \n  position: relative;\n}\n.home_page_slots_top_container {\n  width: 100%;\n  height: 160px;\n  background: linear-gradient(180deg, #140f2d, #140f2d, transparent);\n  position: absolute;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-left: 20px;\n  padding-bottom: 30px;\n  padding-top: 30px;\n}\n.youturn_presents_title,\n.featured_stories_title {\n  color: #fff !important;\n}\n.youturn_presents_title {\n  font-size: 15px !important;\n}\n\n._views {\n  color: #ffffff;\n  font-size: 13px;\n  color: white;\n  font-weight: bold;\n}\n.home_slot_card_views {\n  color: red;\n}\n.views_container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.youturn_presents_title,\n.featured_stories_title {\n  color: #fff !important;\n}\n.youturn_presents_title {\n  font-size: 15px !important;\n}\n.featured_stories_title {\n}\n.hide_content_in_desktop {\n  margin-bottom: 30px;\n  position: relative;\n}\n.home_videos_second_column_overlay_play_button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.home_video_thumbnail_container {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.donate_inr_text {\n  color: gray;\n}\n.home_donation_input_wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: 40px;\n  width: 100%;\n}\n\n.back_button {\n  background: linear-gradient(\n    166.4deg,\n    #140f2d 9.74%,\n    #f49d36 281.54%\n  ) !important;\n  color: white;\n}\n\n.home_article_trending_image {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover;\n  border-radius: 8px 8px 8px 8px !important;\n}\n\n.home_donation_input {\n  width: 100%;\n  height: 100%;\n}\n.user_details_submit_button {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 5px;\n  margin-bottom: 20px;\n}\n.user_detail_mobile_no_input {\n  width: 100%;\n}\n.submit_button {\n  background-color: #00acee;\n  color: white;\n  height: auto;\n}\n\n.submit_button:hover {\n  background-color: #00acee !important;\n  color: white !important;\n}\n.home_donate_button_disabled {\n  background-color: #140f2d !important;\n  color: gray !important;\n  cursor: not-allowed !important;\n  border: none;\n  opacity: 1;\n}\n.thank_you_modal_content {\n  text-align: center;\n}\n\n.thank_you_image {\n  border-radius: 9px;\n  z-index: 1;\n  object-fit: cover;\n  height: 170px;\n  margin-top: 4vh;\n}\n\n.thank_you_message {\n  margin-top: 4vh;\n}\n.home_article_card_author_name_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-family: \"Lato\";\n  \n  font-size: 15px !important;\n}\n.featured_stories_title {\n  font-weight: 700;\n  font-family: \"Lato\";\n  \n}\n\n.slot_card_details {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  gap: 10px;\n  \n}\n.fact_check_first_column_card_container {\n  background-color: #fff !important;\n  box-shadow: var(--border-shadow);\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  \n  overflow: hidden;\n  cursor: pointer;\n  border-radius: 0px 0px 10px 10px;\n}\n.slot_main_container {\n  width: 24%;\n  background-color: #fff !important;\n  box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  margin-bottom: 50px;\n  overflow: hidden;\n  cursor: pointer;\n  border-radius: 0px 0px 10px 10px;\n  justify-content: space-between;\n}\nbody.dark_mode .slot_main_container{\n  background-color: #2d2d2d !important;\n}\n.slot_image_box {\n  width: 100%;\n  height: 170px;\n  object-fit: cover;\n}\n.slot_card_title {\n  font-family: \"Lato\";\n  font-size: 14px;\n  font-weight: 700 !important;\n}\n.slot_card_title_en {\n  font-family: \"Lato\";\n  font-size: 14px;\n  font-weight: 700 !important;\n}\n.slot_card_sub_title {\n  font-size: 11px;\n  color: var(--subtitle-color);\n  height: 130px !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  font-family: \"Lato\";\n}\n.slot_card_footer_content {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.home_slot_description {\n  font-size: 12px;\n}\n.home_slot_title {\n  font-size: 28px;\n}\n.home_slot_youturn_present_title {\n  font-size: 10px;\n}\n.home_slots_background_image_container {\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  justify-content: flex-start;\n  width: 100%;\n  margin-top: 280px;\n  padding-left: 50px;\n}\n.slot_card_sub_title_en {\n  text-align: justify;\n  color: #61666d;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  overflow: hidden;\n}\n.slot_image {\n  width: 100%;\n  height: 100%;\n}\n\n.slot_main_container:hover > .image_hover_effect {\n  transform: var(--image-hover-transform);\n  transition: var(--image-hover-transition);\n}\n.home_slot_mobile_image {\n  height: 100%;\n  object-fit: contain;\n  width: 100%;\n}\n.home_slot_mobile_image_box {\n  width: 100%;\n  max-height: 500px;\n  object-fit: contain;\n}\n.home_slot_mobile_carousel_container {\n  margin-top: 20%;\n}\n.margin_zero {\n  margin: 0px !important;\n}\n.width-100 {\n  width: 100% !important;\n}\n.home_slot_card_author_detail {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  \n}\n.slot_card_title_container {\n  overflow: hidden;\n  overflow: hidden;\n  font-family: \"Kufam\";\n  font-weight: 600;\n}\n.continue_reading_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.user_contributed_story_container_footer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  height: auto;\n}\n.home_slot_view_time_wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n}\n.slot_card_subtitle_container {\n  overflow: hidden;\n}\n.slot_card_subtitle_container,\n.slot_card_subtitle_container_ta {\n  overflow: hidden;\n  color: gray;\n}\n.home_slot_card_author_name {\n  font-weight: 400;\n}\n.fact_check_first_column_card_container:hover > .image_hover_effect {\n  transform: var(--image-hover-transform);\n  transition: var(--image-hover-transition);\n}\n\n.home_article_trending_container_skeleton {\n  width: 100% !important;\n  border-radius: 8px;\n  display: flex !important;\n  flex-direction: column;\n  justify-content: flex-end !important;\n  position: relative;\n}\n\n.home_article_sec_column_inner_row_content_skeleton {\n  width: 100% !important;\n  height: 200px !important;\n}\n.exposing_fake_news_first_column_image_skeleton {\n  width: 100% !important;\n  height: 100% !important;\n}\n.fact_check_first_column_card_container_loading {\n  background-color: #fff !important;\n  box-shadow: var(--border-shadow);\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  \n  overflow: hidden;\n  cursor: pointer;\n  border-radius: 0px 0px 10px 10px;\n  height: 100%;\n}\n.home_trending_author_text {\n  color: white;\n  font-family: \"Lato\";\n}\n.exposing_fake_news_second_column_image_skeleton {\n  width: 100% !important;\n  height: 150px !important;\n}\n.home_trending_title_text_en {\n  color: white;\n  font-family: \"Lato\";\n  font-weight: 800;\n}\n.exposing_fake_news_first_column_title_ta {\n  color: #ffffff;\n}\n\n.exposing_fake_news_third_skeleton {\n  display: flex !important;\n  gap: 5px !important;\n  width: 100%;\n}\n.zoom-effect {\n  overflow: hidden;\n  position: relative;\n}\n.slot_main_container:hover > .zoom-effect img {\n  transform: scale(1.1);\n  transition: transform 0.8s ease-in-out;\n}\n\n.home_user_contribution_card_container:hover\n  > .home_user_contribution_image\n  img {\n  transform: scale(1.1);\n  transition: transform 0.8s ease-in-out;\n}\n.home_user_contribution_card_container:not(:hover)\n  > .home_user_contribution_image\n  img {\n  transition: transform 0.9s ease-in-out; \n}\n.slot_main_container:not(:hover) > .zoom-effect img {\n  transition: transform 0.9s ease-in-out; \n}\n\n.home_user_contribution_vertical_image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.home_user_contribution_second_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 10px;\n  width: 60%;\n}\n.home_videos_title_text_ta {\n  color: #fff;\n  text-align: left;\n  font-family: \"Kufam\";\n}\n.home_page_videos_text_content_ta {\n  color: #fff;\n  font-size: large;\n  width: 100%;\n}\n.submit_claim_form {\n  padding: 15px 15px 0px 15px;\n}\n.thank_you_modal_content_main_container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  height: 400px;\n}\n.badge_selected:hover {\n  background-color: #00adee !important;\n  color: white !important;\n  border: none !important;\n}\n\n.user_contribution_mobile_title_and_top_contributors {\n  padding: 0 0 0 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.home_article_title_container {\n  gap: 20px;\n}\n.donation_amount_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.home_amount_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.home_donation_third_column_division {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 15px;\n}\n.writing_image_div,\n.scroll_to_top_icon_div {\n  transition: opacity 2s ease-in-out !important;\n}\n\n.bell_image {\n  width: 60px;\n  height: 60px;\n  position: fixed;\n  left: 80px;\n  bottom: 10px;\n  background-color: #0065cc;\n  box-shadow: 4px 4px 10px rgba(20, 15, 45, 0.3);\n  border-radius: 50%; \n  z-index: 99;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center; \n}\n\n.bell_icon {\n  width: 30px; \n  height: 30px;\n}\n\n.bell_image,\n.scroll_to_top_icon_div {\n  transition: opacity 2s ease-in-out !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
